export default __webpack_public_path__ + "static/media/hecho_en_mexico.cb35e3ab.png";